<template>
  <ul>
    <li v-for="node in nodes" :key="node.slug">
      <router-link
        :to="
          lang ? '/' + lang + path + '/' + node.slug : path + '/' + node.slug
        "
      >
        <span>
          <span>{{ categoryName(node) }}</span>
        </span>
      </router-link>
      <div>
        <MenuNode2
          v-if="node.children.length"
          :nodes="node.children"
          :depth="depth + 1"
          :path="`${path}/${node.slug}`"
        />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MenuNode2',
  props: {
    nodes: {
      type: Array,
      required: true,
    },
    depth: {
      type: Number,
      required: false,
      default: 0,
    },
    path: {
      type: String,
      required: false,
      default: '/product-category',
    },
    iphone: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    categoryName(cat) {
      //console.log(cat)
      return cat[`name_${this.$i18n.locale}`] || cat.name || '.....'
    },
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>
